<template>
  <div>
  <licitacao-fornecedor-esclarecimento-impugnacao-nao-habilitado v-if="!licitacao.esclarecimentoImpugnacao"/>
  <div v-else>
    <div class="">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">
            Solicitar
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
              v-for="(tipo) in tiposAnexoFornecedor"
              :key="tipo.chave"
              @click="abrirModalSolicitacao(tipo.chave)"
          >
            <v-list-tile-title>{{ tipo.label }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <esclarecimento-impugnacao v-model="licitacao"></esclarecimento-impugnacao>
    <solicitacao-esclarecimento-impugnacao
                                           v-if="exibirModalSolicitacao"
                                           :item="tipoSelecionado"
                                           :solicitacao="dadosGeraisSolicitacao"
                                           @fecharDetalhe="exibirModalSolicitacao = false"
                                           @solicitacaoSalva="buscaTodos()"
                                           @solicitacaoEnviada="buscaTodos()"
    />
    <az-dialog v-if="exibirModalDataAbertura"
               :width=600 @ok="exibirModalDataAbertura = false">
      <div>
        <span>Caro senhor fornecedor, conforme a legislação não é permitido solicitar {{tipoSelecionado | tipoAnexoFornecedor}} do edital após a data limite.</span>
      </div>
    </az-dialog>
    <az-dialog v-if="exibirModalLicitacaoEncerrada"
               :width=600 @ok="exibirModalLicitacaoEncerrada = false">
      <div>
        <span>Caro senhor fornecedor, não é possível enviar um esclarecimento/impugnação para um processo encerrado.</span>
      </div>
    </az-dialog>
  </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import moment from "moment"
import {actionTypes, tiposAnexoFornecedor} from '@/commons/constants'
import EsclarecimentoImpugnacao from '../commons/EsclarecimentoImpugnacao'
import SolicitacaoEsclarecimentoImpugnacao from '../fornecedor/modal/LicitacaoFornecedorEsclarecimentoSolicitacao'
import LicitacaoFornecedorEsclarecimentoImpugnacaoNaoHabilitado
  from "@/views/licitacao/detalhe/fornecedor/LicitacaoFornecedorEsclarecimentoImpugnacaoNaoHabilitado";

export default {
    name: "LicitacaoFornecedorEsclarecimentoImpugnacao",
    components: {
      LicitacaoFornecedorEsclarecimentoImpugnacaoNaoHabilitado,
      EsclarecimentoImpugnacao, SolicitacaoEsclarecimentoImpugnacao},
    data(){
      return {
        tipoSelecionado: undefined,
        exibirModalSolicitacao: false,
        exibirModalDataAbertura: false,
        exibirModalLicitacaoEncerrada: false,
        dadosGeraisSolicitacao: {
              licitacao: {id: undefined},
              assunto: '',
              usuario: {id: undefined},
              tipo: '',
              arquivoUri: null,
              arquivoNome: null,
              repositorioUri: null
        }
      }
    },
    computed: {
        tiposAnexoFornecedor(){
          return tiposAnexoFornecedor
        },
        ...mapState(['licitacao'])
    },
    async mounted() {
        await this.buscarEsclarecimentosLicitacao()
        await this.buscarImpugnacoesLicitacao()
    },
    methods: {
        validaDataDeAbertura(){
          return moment().tz('America/Sao_Paulo').format() > moment(this.licitacao.dataLimiteEsclarecimentoImpugnacao).tz('America/Sao_Paulo').format();
        },
        abrirModalSolicitacao(tipo){
          this.tipoSelecionado = tipo

          if(this.licitacao.status === 'ENCERRADO')
              this.exibirModalLicitacaoEncerrada = true
          else if(this.validaDataDeAbertura())
              this.exibirModalDataAbertura = true
          else
            this.exibirModalSolicitacao = true
        },
        async buscarEsclarecimentosLicitacao() {
            this.setMensagemLoading('Atualizando listagem de esclarecimentos...')
            await this.buscarEsclarecimentos(this.$route.params.id)
        },
        async buscarImpugnacoesLicitacao() {
            this.setMensagemLoading('Atualizando listagem de impugnações...')
            await this.buscarImpugnacoes(this.$route.params.id)
        },
        buscaTodos(){
          this.buscarImpugnacoesLicitacao()
          this.buscarEsclarecimentosLicitacao()
          this.exibirModalSolicitacao = false;
        },
        ...mapActions([
            actionTypes.BUSCAR_ESCLARECIMENTOS
          , actionTypes.BUSCAR_IMPUGNACOES])
    },
    filters: {
      tipoAnexoFornecedor(tipoAnexoChave) {
        const tipoSelecionado = tiposAnexoFornecedor.find(tipoObj => tipoObj.chave === tipoAnexoChave)
        return tipoSelecionado ? tipoSelecionado.label : ''
      }
    }
}
</script>

<style scoped>

</style>